import React from "react"
import styled from "styled-components/macro"
import Footer from "./Footer"
import { ScrollToTop } from "../buttons"

const Container = styled.div`
  background: white;
`

const Layout = props => {
  return (
    <Container>
      <ScrollToTop />
      <div {...props}>{props.children}</div>
      <Footer />
    </Container>
  )
}

export default Layout
